export default __webpack_public_path__ + "static/media/swap.80b5ab13.svg";